import { makeStyles } from 'makeStyles';
import { ALERT_BACKGROUND, ALERT_BACKGROUND_BORDER } from 'theme/colors';

export const useStyles = makeStyles()(() => ({
  alertWrapper: {
    backgroundColor: ALERT_BACKGROUND,
    border: `1px solid ${ALERT_BACKGROUND_BORDER}`,
    borderRadius: 3,
    padding: '12px 13px',
  },
  alertIconWrapper: {
    paddingLeft: 8,
  },
  alertTextWrapper: {
    paddingRight: 8,
  },
  dismissableAlert: {
    position: 'relative',
  },
  dismissIcon: {
    position: 'absolute',
    right: 29,
    top: 29,
    cursor: 'pointer',
  },
}));
